import { render, staticRenderFns } from "./OnlineCourseRegularButton.vue?vue&type=template&id=2e94a318&"
import script from "./OnlineCourseRegularButton.vue?vue&type=script&lang=js&"
export * from "./OnlineCourseRegularButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e94a318')) {
      api.createRecord('2e94a318', component.options)
    } else {
      api.reload('2e94a318', component.options)
    }
    module.hot.accept("./OnlineCourseRegularButton.vue?vue&type=template&id=2e94a318&", function () {
      api.rerender('2e94a318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/OnlineCourseRegularButton.vue"
export default component.exports